import { usePinFormState } from "./usePinFormState.ts";
import { useMutation } from "@tanstack/react-query";
import { authDeviceMutationFn } from "../../../../../api";
import { useEffect } from "react";
import { EPinState } from "../../../../../store/pinFormStore.ts";
import { getPinRequestErrorMessage } from "../utils";
import { usePersistStore } from "../../../../../store/persistStore.ts";

export function useAuthenticateDeviceMutationReaction() {
  const pinFormState = usePinFormState();
  const persistStore = usePersistStore();
  const authDevice = useMutation({
    mutationKey: ["addDevice"],
    mutationFn: authDeviceMutationFn,
  });

  useEffect(() => {
    switch (authDevice.status) {
      case "success": {
        pinFormState.setState(EPinState.Submitted);
        persistStore.setDeviceJwt(authDevice.data.token);
        return;
      }
      case "error": {
        pinFormState.setState(EPinState.Initial);
        pinFormState.setError(getPinRequestErrorMessage(authDevice.error));
      }
    }
  }, [authDevice.status]);

  return authDevice;
}
